import * as i0 from '@angular/core';
import { input, computed, signal, effect, Directive, HostListener } from '@angular/core';
import { deepCopy } from '@futura/futura-ui/core';
const BREAKPOINT_VALUES = {
  xs: 0,
  // mobile
  s: 320,
  // mobile
  ms: 375,
  // mobile
  sm: 575,
  // mobile
  md: 767,
  // mobile
  lg: 991,
  // tablet
  xl: 1199,
  // desktop
  xxl: 1399 // desktop
};
function getWidth(breakpoint) {
  if (typeof breakpoint === 'string') {
    return BREAKPOINT_VALUES[breakpoint];
  } else {
    return breakpoint;
  }
}
function isMobile(breakpoint) {
  return getWidth(breakpoint) <= BREAKPOINT_VALUES.md;
}
function isTablet(breakpoint) {
  const width = getWidth(breakpoint);
  return width > BREAKPOINT_VALUES.md && width <= BREAKPOINT_VALUES.lg;
}
function isDesktop(breakpoint) {
  return getWidth(breakpoint) > BREAKPOINT_VALUES.lg;
}
let BreakpointDirective = /*#__PURE__*/(() => {
  class BreakpointDirective {
    constructor(templateRef, viewContainer) {
      this.templateRef = templateRef;
      this.viewContainer = viewContainer;
      this.futBreakpoint = input();
      this.fromBreakpoint = computed(() => this.futBreakpoint()?.from || 'xs');
      this.toBreakpoint = computed(() => this.futBreakpoint()?.to || 'xxl');
      this.futBreakpointDisable = input();
      this.currentSize = signal(window.innerWidth);
      this.hasView = false;
      effect(() => {
        const from = this.fromBreakpoint();
        const to = this.toBreakpoint();
        const disable = !!this.futBreakpointDisable();
        const currentSize = this.currentSize();
        this.setView(disable, from, to, currentSize);
      }, {
        allowSignalWrites: true
      });
    }
    onResize() {
      this.currentSize.set(window.innerWidth);
    }
    setView(disable, from, to, currentSize) {
      if (disable) {
        this.componentToggle(true);
        return;
      }
      const fromSize = BREAKPOINT_VALUES[from];
      const toSize = BREAKPOINT_VALUES[to] || fromSize;
      const currentBreakpoint = this.getCurrentBreakpoint(currentSize);
      this.componentToggle(from === currentBreakpoint || to === currentBreakpoint || currentSize >= fromSize && currentSize <= toSize);
    }
    componentToggle(show) {
      if (show) {
        if (!this.hasView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
        }
      } else {
        if (this.hasView) {
          this.viewContainer.clear();
          this.hasView = false;
        }
      }
    }
    getCurrentBreakpoint(currentSize) {
      const breakpoint = deepCopy(Object.entries(BREAKPOINT_VALUES)).reverse().find(([_, value]) => currentSize >= value);
      return breakpoint ? breakpoint[0] : 'xs';
    }
    static {
      this.ɵfac = function BreakpointDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BreakpointDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BreakpointDirective,
        selectors: [["", "futBreakpoint", ""]],
        hostBindings: function BreakpointDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("resize", function BreakpointDirective_resize_HostBindingHandler($event) {
              return ctx.onResize($event);
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          futBreakpoint: [1, "futBreakpoint"],
          futBreakpointDisable: [1, "futBreakpointDisable"]
        },
        standalone: true
      });
    }
  }
  return BreakpointDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BREAKPOINT_VALUES, BreakpointDirective, isDesktop, isMobile, isTablet };
